export const CURRENCY_SYMBOLS: Record<string, string> = {
  ZAR: 'R',
  USD: '$',
  GBP: '£',
  EUR: '€',
  NGN: '₦',
  KES: 'KSh',
  GHS: '₵',
};

export const TIMEFRAME_DISPLAY: Record<string, string> = {
  a_few_days: 'in a few days',
  a_few_weeks: 'in a few weeks',
  one_to_three_months: 'in 1–3 months',
  three_to_six_months: 'in 3–6 months',
  six_plus_months: 'in 6+ months',
};
